import axios from 'axios'

const axiosInstance = axios.create({
  //baseURL: process.env.VUE_APP_WEBAPI || '', // if you use a base URL
  // ...any interceptors / headers you need
})

export async function fetchData(url, params = {}, method="get", returntype = 'data') {
  try {

 

    const isServer = typeof window === 'undefined';

    const baseURL = isServer
    ? process.env.VUE_APP_WCF_INTERNAL
    : process.env.VUE_APP_WEBAPI;



    url = baseURL + url;

    let response;

    if (method.toLowerCase()=='get') {

      response = await axiosInstance.get(url,params)

    } else {
     
      response = await axiosInstance.post(url,params)
    }
    switch (returntype) {
      case 'data':
        return response.data
        
      default:
        return response.data
    }

  } catch (err) {
   
    console.error("[API] fetchCompetitions error: url-" + url, err.message)
    //throw err
  }
}

export async function fetchDataGeneric(url, jsonparams = {}, spname = '', method="get", returntype = 'data') {
  try {

 

    const isServer = typeof window === 'undefined';

    const baseURL = isServer
    ? process.env.VUE_APP_WCF_INTERNAL
    : process.env.VUE_APP_WEBAPI;

    url = baseURL + url;

    let response;

    console.log(url)

    if (method.toLowerCase()=='get') {
      
      response = await axiosInstance.get(url,
        {
          params: {
            SPName: spname,
            Params: jsonparams
          }
        });


      
    } else {
     
      
      response = await axiosInstance.post(url,
        {
         
            SPName: spname,
            Params: jsonparams
        
        });

    }

   

    switch (returntype) {
      case 'data':
        return response.data
        
      default:
        return response.data
    }

  } catch (err) {
   
    console.error("[API] fetchCompetitions error: url-" + url, err.message)
    throw err
  }
}